export default {"src":"/_next/static/media/css.e5e99f36.svg","height":290,"width":256,"blurWidth":0,"blurHeight":0};